import React, { useEffect, useRef, useState, useCallback } from "react";
import {
  Box,
  Button,
  Divider,
  FormControl,
  Grid,
  Switch,
  useMediaQuery,
} from "@mui/material";
import { Typography } from "@mui/material";
import YmmAutocompleteField from "./YmmAutocompleteField";
import AppButton from "../../base/AppButton.component";
import { useVerification } from "../../../context/Verification.context";
import { useAppContext } from "../../../context/App.context";
import { REQUEST_QUOTE } from "../../../graphql/mutation/mutation";
import { useMutation, useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { FETCH_YMMT } from "../../../graphql/query/query";
import Theme from "../../../utils/Theme";
import { UPDATE_ARTIFACT_LOG_LANGUAGE } from "../../../graphql/mutation/mutation"; // ✅ Added import
import { navigateAfterQuote } from "../../../utils/videoPlayer";
import CustomControlsVideoPlayer from "../heygenAI/CustomControlsVideoPlayer";
import { ArtifactStyle } from "./document/artifactResponse/VerficationArtifactsStyles";

const QuoteQuestionsComponent = ({
  fetchQuestionnaire,
  queryLoading,
  open,
  artifact,
}) => {
  const app = useAppContext();
  const verification = useVerification();
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const overlayLatchedRef = useRef(false);
  const isMobile = useMediaQuery("(max-width:750px)");
  const [buttonStates, setButtonStates] = useState([]);
  const [containedstate, setContainedState] = useState([]);
  // const [vehicleDetail, setVehicleDetail] = useState({
  //   vin: "",
  //   year: "",
  //   make: "",
  //   model: "",
  // });
  const { vehicleDetail, setVehicleDetail } = verification;
  const [searchTerm, setSearchTerm] = useState("");

  const [saveYear, setSaveYear] = useState(null);
  const [saveMake, setSaveMake] = useState(null);
  const [saveModel, setSaveModel] = useState(null);

  const [selectedUrl, setSelectedUrl] = useState(null);
  const [animateIn, setAnimateIn] = useState(false);
  const [duration, setDuration] = useState(0);
  const [direction, setDirection] = useState(null);
  const [showSurveyButton, setShowSurveyButton] = useState(false);
  const [isSpokeperson, setIsSpokeperson] = useState(false);
  const [isSpanish, setIsSpanish] = useState(false);
  const [loading, setIsLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");

  const { data: fetchOutput, refetch } = useQuery(FETCH_YMMT, {
    variables: {
      ymmtInput: {
        year: vehicleDetail.year,
        make: vehicleDetail.make,
        model: vehicleDetail.model,
      },
    },
  });

  useEffect(() => {
    if (fetchOutput?.fetchYmmt) {
      if (
        vehicleDetail.year === "" &&
        vehicleDetail.make === "" &&
        vehicleDetail.model === ""
      ) {
        const currentYear = new Date().getFullYear();
        const nextYear = currentYear + 1;

        const rawYears = fetchOutput.fetchYmmt.yearArray ?? [];

        const yearInDesc = rawYears
          .map(Number)
          .filter((y) => y !== 9999)
          .filter((y) => y <= nextYear)
          .sort((a, b) => b - a);

        setSaveYear(yearInDesc.map(String));
        setSaveMake([]);
        setSaveModel([]);
      } else if (
        vehicleDetail.year &&
        vehicleDetail.make === "" &&
        vehicleDetail.model === ""
      ) {
        setSaveMake(fetchOutput.fetchYmmt.makeArray || []);
        setSaveModel([]);
      } else if (
        vehicleDetail.year &&
        vehicleDetail.make &&
        vehicleDetail.model === ""
      ) {
        setSaveModel(fetchOutput.fetchYmmt.modelArray || []);
      }
    }
  }, [fetchOutput, vehicleDetail]);

  const [requestQuote, { loading: requestLoading }] = useMutation(
    REQUEST_QUOTE,
    {
      onCompleted: (data) => {
        if (data?.requestQuote.dealership_id) {
          navigateAfterQuote(navigate, verification);
        } else {
          console.log("error");
        }
      },
    }
  );

  const handleClick = (index, option, id) => {
    setButtonStates((prevButtonStates) => {
      const updatedButtonStates = [...prevButtonStates];
      const existingIndex = updatedButtonStates.findIndex(
        (item) => item.question_id === id
      );
      if (existingIndex !== -1) {
        updatedButtonStates[existingIndex].response = option;
      } else {
        updatedButtonStates.push({ question_id: id, response: option });
      }
      return updatedButtonStates;
    });
  };

  useEffect(() => {
    if (
      verification?.customer?.claims &&
      fetchQuestionnaire?.fetchQuestionnaire?.questionsArray[1]
    ) {
      setButtonStates((prevButtonStates) => {
        const updatedButtonStates = [...prevButtonStates];
        const existingIndex = updatedButtonStates.findIndex(
          (item) =>
            item.question_id ===
            fetchQuestionnaire?.fetchQuestionnaire?.questionsArray[1]?.id
        );
        if (existingIndex !== -1) {
          updatedButtonStates[existingIndex].response = "YES";
        } else {
          updatedButtonStates.push({
            question_id:
              fetchQuestionnaire?.fetchQuestionnaire?.questionsArray[1]?.id,
            response: "YES",
          });
        }
        return updatedButtonStates;
      });
    }
  }, [
    verification?.customer?.claims,
    fetchQuestionnaire?.fetchQuestionnaire?.questionsArray,
  ]);

  const handleContained = (index, option) => {
    setContainedState((prevButtonStates) => ({
      ...prevButtonStates,
      [index]: option,
    }));
  };

  const handleSubmit = () => {
    const stringifyAnswers = JSON.stringify(buttonStates);
    requestQuote({
      variables: {
        requestInput: {
          employee_user_id: parseInt(verification.employeeId),
          user_id: verification.customer.userId,
          dealership_id: parseInt(verification.dealershipId),
          d_startDate: app.fetchData.d_startDate,
          d_endDate: app.fetchData.d_endDate,
          f_startDate: app.fetchData.f_startDate,
          f_endDate: app.fetchData.f_endDate,
          pageCount: app.fetchData.pageCount,
          rowsPerPage: app.fetchData.rowsPerPage,
          search_employee: app.fetchData.searchEmployee,
          search_customer: app.fetchData.searchCustomer,
          isEmployeeOnly: false,
          timezone: new Date().getTimezoneOffset(),
          answers: buttonStates,
          isRequestQuote: true,
          insuranceCompleted: verification?.pullInsurance ? true : false,
          insurance_id: verification?.customer?.insurance_id,
          type: "notification",
          vin: vehicleDetail.vin,
          year: vehicleDetail.year,
          make: vehicleDetail.make,
          model: vehicleDetail.model,
        },
      },
    });
  };

  useEffect(() => {
    if (!artifact?.questionnaire_ai_url) return;
    if (!isSpokeperson) {
      setSelectedUrl(null);
      return;
    }

    overlayLatchedRef.current = false;
    setShowSurveyButton(false);

    const url = isSpanish
      ? artifact.questionnaire_ai_url.spanish_url
      : artifact.questionnaire_ai_url.english_url;

    if (url) setSelectedUrl(url);
  }, [artifact, isSpanish, isSpokeperson]);

  useEffect(() => {
    if (!selectedUrl) {
      setIsLoading(false);
      setAnimateIn(false);
      return;
    }
    setIsLoading(true);
    setAnimateIn(false);
  }, [selectedUrl]);

  // ── Overlay reveal / latch, mirrors FetchAIVideoUrl's pattern ──
  const revealQuestions = useCallback(() => {
    overlayLatchedRef.current = true;
    setShowSurveyButton(true);
  }, []);

  const resetOverlayLatch = useCallback(() => {
    overlayLatchedRef.current = false;
    setShowSurveyButton(false);
  }, []);

  const handleVideoEnded = useCallback(() => {
    revealQuestions();
  }, [revealQuestions]);

  const handleVideoTimeUpdate = useCallback(
    (currentTime, dur) => {
      if (!dur || !isFinite(dur)) return;

      const nearEnd = dur - currentTime <= 0.5;

      if (nearEnd) {
        revealQuestions();
      } else {
        // User rewound / seeked away from the end — reset the latch so
        // the video can play again and the overlay hides until earned
        // again (near-end or ended). This fixes the replay button being
        // blocked after the first playthrough on the Quote Questions page
        // because holdAtEnd stayed true permanently once latched.
        overlayLatchedRef.current = false;
        setShowSurveyButton(false);
      }
    },
    [revealQuestions],
  );

  // Reset/cleanup when spokesperson mode is turned off, mirroring the
  // old <video> element's teardown behavior.
  useEffect(() => {
    if (!isSpokeperson) {
      resetOverlayLatch();
      setAnimateIn(false);
      setIsLoading(false);
    }
  }, [isSpokeperson, resetOverlayLatch]);

  useEffect(() => {
    if (
      verification?.aiData?.spokeperson &&
      verification?.tradeQuote?.length > 0
    ) {
      setIsSpokeperson(verification?.aiData?.spokeperson);
      setIsSpanish(verification?.aiData?.spanish);
    }
  }, []);

  const FetchQuestions = () => {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: 1, md: 0.5 }, p: { xs: 1, md: "4px" } }}>
        {fetchQuestionnaire?.fetchQuestionnaire?.questionsArray.map(
          (question, index) => {
            let options = JSON.parse(question.options)
              ? JSON.parse(question.options)
              : [""];
            let es_options = JSON.parse(question.es_options)
              ? JSON.parse(question.es_options)
              : [""];
            return (
              <React.Fragment key={index}>
                {verification?.customer?.claims && index === 1 ? null : (
                  <>
                    <Box style={{ fontSize: "19px", fontWeight: "bold" }}>
                      <Typography key={index} sx={{ fontWeight: "bold" }}>
                        {isSpanish ? question?.es_question : question.question}
                      </Typography>
                    </Box>

                    <Grid
                      container
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 3,
                        justifyContent: "center",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      {(isSpanish ? es_options : options)?.map(
                        (ans, optionIndex) => (
                          <React.Fragment key={optionIndex}>
                            <AppButton
                              key={optionIndex}
                              buttonText={ans}
                              size="medium"
                              variant={
                                containedstate[index] === ans
                                  ? "contained"
                                  : "outlined"
                              }
                              sx={{
                                width: { xs: "45%", sm: "45%", md: "21%", lg: "21%" },
                                height: { xs: "70%", sm: "70%", md: "auto", lg: "auto" },
                                fontWeight: "bold",
                              }}
                              clickHandler={() => {
                                handleClick(index, ans, question?.id);
                                handleContained(index, ans);
                              }}
                            />
                          </React.Fragment>
                        )
                      )}
                    </Grid>
                  </>
                )}
              </React.Fragment>
            );
          }
        )}

        {!(verification.artifacts?.vehicleTransactionArtifact?.length > 0) && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              pb: 1,
              gap: { xs: 0.2, sm: 0.2, md: 2, lg: 0.2 },
            }}
          >
            <Box style={{ fontSize: "19px", fontWeight: "bold" }}>
              <Typography sx={{ fontWeight: "bold", mb: 1 }}>
                {isSpanish
                  ? "Por favor, actualice los datos de su vehículo"
                  : "Please update your vehicle details"}
              </Typography>
            </Box>
            <Box
              display="flex"
              flexDirection={"row"}
              justifyContent="space-between"
              gap={1}
              width="100%"
              px={{ xs: 0.7, sm: 2, md: 1, lg: 1, xl: 1 }}
            >
              <FormControl sx={{ width: "100%" }}>
                <YmmAutocompleteField
                  fieldType="year"
                  options={saveYear || []}
                  value={vehicleDetail.year || ""}
                  label={isSpanish ? "Año" : "Year"}
                  isSpanish={isSpanish}
                  textFieldSx={{ backgroundColor: "white" }}
                  paperSx={{ maxHeight: 200 }}
                  onChange={(newValue) => {
                    setSaveMake([]);
                    setSaveModel([]);
                    setVehicleDetail({
                      ...vehicleDetail,
                      year: newValue,
                      make: "",
                      model: "",
                    });
                  }}
                  onRefetch={(newValue) =>
                    refetch({
                      ymmtInput: { year: newValue, make: "", model: "" },
                    })
                  }
                />
              </FormControl>

              <FormControl sx={{ width: "100%" }}>
                <YmmAutocompleteField
                  fieldType="make"
                  options={saveMake || []}
                  value={vehicleDetail.make || ""}
                  label={isSpanish ? "Hacer" : "Make"}
                  isSpanish={isSpanish}
                  disabled={!vehicleDetail.year}
                  textFieldSx={{ backgroundColor: "white" }}
                  onChange={(newValue) => {
                    setSaveModel([]);
                    setVehicleDetail({
                      ...vehicleDetail,
                      make: newValue,
                      model: "",
                    });
                  }}
                  onRefetch={(newValue) =>
                    refetch({
                      ymmtInput: {
                        year: vehicleDetail.year,
                        make: newValue,
                        model: "",
                      },
                    })
                  }
                />
              </FormControl>

              <FormControl sx={{ width: "100%" }}>
                <YmmAutocompleteField
                  fieldType="model"
                  options={saveModel || []}
                  value={vehicleDetail.model || ""}
                  label={isSpanish ? "Modelo" : "Model"}
                  isSpanish={isSpanish}
                  disabled={!vehicleDetail.make || !vehicleDetail.year}
                  textFieldSx={{ backgroundColor: "white" }}
                  onChange={(newValue) => {
                    setVehicleDetail({ ...vehicleDetail, model: newValue });
                  }}
                />
              </FormControl>
            </Box>
          </Box>
        )}
      </Box>
    );
  };

  const Toggle = () => {
    const verification = useVerification();
    const [languageOpen, setLanguageOpen] = useState(false);
    const [modeOpen, setModeOpen] = useState(false);

    // ✅ Same mutation as ToggleComponent
    const [updateArtifactLogLanguage] = useMutation(UPDATE_ARTIFACT_LOG_LANGUAGE, {
      onCompleted: (data) => {
        console.log("Language updated in artifact log", data);
      },
      onError: (err) => {
        console.error("Error updating artifact log language", err);
      },
    });

    // ✅ Same helper function as ToggleComponent
    const handleLanguageChange = (newIsSpanish) => {
      setIsSpanish(newIsSpanish);
      setLanguageOpen(false);

      console.log("verification object 👉", verification);
      console.log("FINAL PAYLOAD", {
        dealership_id: Number(verification?.dealershipId),
        employee_user_id: Number(verification?.employeeId),
        user_id: Number(verification?.customer?.userId),
        language_id: newIsSpanish ? 2 : 1,
        updated_by: Number(verification?.employeeId),
      });

      updateArtifactLogLanguage({
        variables: {
          updateArtifactLogLanguageInput: {
            dealership_id: Number(verification?.dealershipId),
            employee_user_id: Number(verification?.employeeId),
            user_id: Number(verification?.customer?.userId),
            language_id: newIsSpanish ? 2 : 1,
            updated_by: Number(verification?.employeeId),
          },
        },
      });
    };

    const dropdownButtonStyles = {
      padding: "13px 7px",
      fontSize: window.innerWidth <= 750 ? "10px" : "12px",
      cursor: "pointer",
      color: Theme.palette.primary.main,
      fontWeight: 500,
      width: window.innerWidth <= 750 ? "70px" : "80px",
      height: window.innerWidth <= 750 ? "32px" : "36px",
      display: "flex",
      alignItems: "center",
      position: "relative",
      justifyContent: "space-between",
    };

    const dropdownContentStyles = {
      position: "absolute",
      top: "100%",
      left: "0%",
      backgroundColor: "#fff",
      width: {
        xs: "100%",
        sm: "80%",
        md: "45%",
        lg: "45%",
      },
      boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
      zIndex: 1000,
      borderRadius: "4px",
      border: "1px solid #ddd",
      marginTop: "4px",
      overflow: "hidden",
    };

    const dropdownItemStyles = {
      padding: "10px 12px",
      cursor: "pointer",
      fontSize: window.innerWidth <= 750 ? "10px" : "12px",
      backgroundColor: "#fff",
      "&:hover": { backgroundColor: "#f5f5f5" },
    };

    const selectedItemStyles = {
      ...dropdownItemStyles,
      backgroundColor: "#defae5ff",
      fontWeight: 600,
      color: Theme.palette.primary.main,
    };

    return (
      <>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            position: "relative",
          }}
        >
          {/* Language Dropdown (EN / ES) */}
          <Box sx={{ position: "relative" }}>
            <Box
              onClick={() => {
                setLanguageOpen(!languageOpen);
                setModeOpen(false);
              }}
              sx={dropdownButtonStyles}
            >
              {isSpanish ? "SPANISH" : "ENGLISH"}
              <span style={{ fontSize: "12px", color: Theme.palette.primary.main }}>
                ▼
              </span>
            </Box>

            {languageOpen && (
              <Box sx={dropdownContentStyles}>
                {/* ✅ Now calls handleLanguageChange instead of just setIsSpanish */}
                <Box
                  onClick={() => handleLanguageChange(false)}
                  sx={!isSpanish ? selectedItemStyles : dropdownItemStyles}
                >
                  ENGLISH
                </Box>
                <Box
                  onClick={() => handleLanguageChange(true)}
                  sx={isSpanish ? selectedItemStyles : dropdownItemStyles}
                >
                  SPANISH
                </Box>
              </Box>
            )}
          </Box>

          {/* Mode Dropdown (AVATAR / READ) */}
          <Box sx={{ position: "relative" }}>
            <Box
              onClick={() => {
                if (!verification?.aiData?.isAI) return;
                setModeOpen(!modeOpen);
                setLanguageOpen(false);
              }}
              sx={{
                ...dropdownButtonStyles,
                opacity: verification?.aiData?.isAI ? 1 : 0.5,
                pointerEvents: verification?.aiData?.isAI ? "auto" : "none",
              }}
            >
              {isSpokeperson ? "AVATAR" : "READ"}
              <span style={{ fontSize: "12px", color: Theme.palette.primary.main }}>
                ▼
              </span>
            </Box>

            {modeOpen && verification?.aiData?.isAI && (
              <Box sx={dropdownContentStyles}>
                <Box
                  onClick={() => {
                    setIsSpokeperson(true);
                    setModeOpen(false);
                  }}
                  sx={isSpokeperson ? selectedItemStyles : dropdownItemStyles}
                >
                  AVATAR
                </Box>
                <Box
                  onClick={() => {
                    setIsSpokeperson(false);
                    setModeOpen(false);
                  }}
                  sx={!isSpokeperson ? selectedItemStyles : dropdownItemStyles}
                >
                  READ
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </>
    );
  };

  const hasMessage = verification.aiData.spanish
    ? !!artifact?.es_text
    : !!artifact?.text;

  return (
    <>
      <Divider />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          p: 2,
          minHeight: "80vh",
        }}
      >
        <>
          {isSpokeperson ? (
            <Box
              sx={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  zIndex: 3,
                  justifyContent: "space-between",
                  alignItems: "start",
                  width: "20%",
                }}
              >
                <Toggle />
              </Box>

              {/* Video zone — same CustomControlsVideoPlayer used by the
                  rest of the avatar flow (FetchAIVideoUrl), so behavior
                  (playsInline / no native fullscreen takeover, custom
                  green controls, shimmer loading state) matches
                  everywhere else in the app. */}
              <Box
                sx={{
                  // No explicit zIndex here on purpose: position + a set
                  // zIndex (even 0) creates a new stacking context, which
                  // traps the player's internal fullscreen zIndex:9999
                  // inside it. That let the sibling Toggle (zIndex: 3)
                  // and the Submit button (normal flow, later in DOM
                  // order) paint on top when maximized. Leaving zIndex
                  // unset lets the player's fixed fullscreen layer escape
                  // to the true top of the stacking order, same as it
                  // does everywhere else this player is used.
                  position: "relative",
                  height: "65vh",
                  minHeight: "415px",
                  width: { xs: "100%", sm: "70%", md: "520px", lg: "520px" },
                  backgroundColor: "#fff",
                  overflow: "hidden",
                  borderRadius: "14px",
                }}
              >
                {selectedUrl && (
                  <CustomControlsVideoPlayer
                    videoRef={videoRef}
                    src={selectedUrl}
                    animateIn={animateIn}
                    holdAtEnd={showSurveyButton}
                    onEnded={handleVideoEnded}
                    onTimeUpdate={handleVideoTimeUpdate}
                    onReady={() => {
                      setIsLoading(false);
                      setAnimateIn(true);
                    }}
                    onDuration={(d) => setDuration(d)}
                    widenPercent={0}
                  />
                )}

                {/* Responses overlay — positioned on top of the video,
                    same as FetchAIVideoUrl's videoResponseOverlay, instead
                    of floating separately below it. Border/background
                    restored explicitly so the outlined card look matches
                    the original <video>-based implementation regardless
                    of what ArtifactStyle.videoResponseOverlay defines. */}
                {showSurveyButton && (
                  <Box
                    sx={{
                      ...ArtifactStyle.videoResponseOverlay,
                      opacity: showSurveyButton ? 1 : 0,
                      bgcolor: "white",
                      border: "2px solid grey",
                      borderRadius: "5px",
                      p: "5px",
                      // p: { xs: "5px", md: "3px" },
                      // gap: { xs: 1, md: 0.5 },
                    }}
                  >
                    <FetchQuestions />
                  </Box>
                )}
              </Box>
            </Box>
          ) : (
            <>
              <Box sx={{ position: "relative" }}>
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    zIndex: 3,
                    justifyContent: "space-between",
                    alignItems: "start",
                    width: "20%",
                  }}
                >
                  <Toggle />
                </Box>

<Box
  sx={{
    display: "flex",
    flexDirection: "column",
    width: "100%",
    p: 1,
    pt: 8,
  }}
>
  {!isSpanish ? (
    <Typography
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "center",
        mb: 2,
        mt: 2,
      }}
    >
      {artifact?.quote_question
        ? artifact?.quote_question
        : "No English version available"}
    </Typography>
  ) : (
    <Typography
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
        alignItems: "center",
      }}
    >
      {artifact?.es_quote_question
        ? artifact?.es_quote_question
        : "No Spanish version available"}
    </Typography>
  )}
</Box>
                {hasMessage && <FetchQuestions />}
              </Box>
            </>
          )}
        </>
        <Box sx={{ display: "flex",  justifyContent: "Center",p: {
  xs: 1,
  sm: 2,
} }}>
          <AppButton
            buttonText={"Submit"}
            size="medium"
            variant={"contained"}
            sx={{
              width: { xs: "100%", sm: "50%", md: "50%", lg: "50%" },
              alignSelf: "center",
            }}
            clickHandler={() => handleSubmit()}
            disabled={requestLoading}
          />
        </Box>
      </Box>
    </>
  );
};

export default QuoteQuestionsComponent;